export const SUPPLIER_SESSION_EXPIRED_EVENT = "supplier-session-expired";

let lastDispatchAt = 0;

/**
 * Tell the supplier auth provider that a protected API request proved the
 * cookie session is no longer recoverable.
 */
export function notifySupplierSessionExpired(reason = "unauthorized") {
  if (typeof window === "undefined") return;

  const now = Date.now();
  if (now - lastDispatchAt < 1000) return;
  lastDispatchAt = now;

  window.dispatchEvent(
    new CustomEvent(SUPPLIER_SESSION_EXPIRED_EVENT, {
      detail: { reason },
    }),
  );
}
